import { useNavigate } from 'react-router-dom';

import { Typography } from '../../../designComponents';
import { FooterSectionStyled } from '../style';

type Menu = {
  label: string;
  url?: string;
}[];

const supportMenu: Menu = [
  {
    label: 'FAQ',
    url: '/faqs',
  },
  {
    label: 'Contact Us',
    url: '/contact',
  },
  {
    label: 'Account',
    url: '/',
  },
];

const Support = () => {
  const navigate = useNavigate();
  return (
    <FooterSectionStyled>
      <Typography fontColor="white" className="title">
        SUPPORT
      </Typography>
      {supportMenu?.map((menu, index) => {
        return (
          <div
            className="menu"
            key={index}
            onClick={() => menu.url && navigate(menu.url)}
          >
            <Typography fontColor="white" className="menu-item">
              {menu?.label}
            </Typography>
          </div>
        );
      })}
    </FooterSectionStyled>
  );
};

export default Support;
